var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocumentSign = function SvgDocumentSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_95_2826",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_95_2826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.95899 9.41666V8.00833H18.6424V9.41666H9.95899ZM9.95899 12.5418V11.1335H18.6424V12.5418H9.95899ZM13.5673 22.8584H6.50072C5.92438 22.8584 5.43724 22.6594 5.0393 22.2615C4.64135 21.8635 4.44238 21.3764 4.44238 20.8001V17.0252H7.04238V3.14172H21.559V12.3043C21.2812 12.3431 21.0284 12.4097 20.8007 12.5042C20.5729 12.5986 20.3562 12.7389 20.1507 12.925V4.55006H8.45072V17.0252H15.9235L14.5152 18.4332H5.85072V20.8001C5.85072 20.9842 5.91301 21.1386 6.03759 21.2632C6.16217 21.3878 6.31655 21.4501 6.50072 21.4501H13.5673V22.8584ZM15.7258 22.8584V20.2668L21.3091 14.7104C21.4123 14.6044 21.5232 14.5304 21.6417 14.4883C21.7601 14.4462 21.8776 14.4252 21.9943 14.4252C22.1181 14.4252 22.24 14.448 22.3599 14.4937C22.48 14.5396 22.5873 14.6084 22.6819 14.7001L23.8736 15.9291C23.9648 16.0324 24.0351 16.1433 24.0846 16.262C24.1342 16.3804 24.159 16.4979 24.159 16.6143C24.159 16.7308 24.1362 16.8491 24.0905 16.9694C24.045 17.0896 23.9727 17.2005 23.8736 17.302L18.3174 22.8584H15.7258ZM16.6924 21.8918H17.9112L21.2652 18.5478L20.6591 17.9249L20.0735 17.3085L16.6924 20.673V21.8918ZM20.6591 17.9249L20.0735 17.3085L21.2652 18.5478L20.6591 17.9249Z",
    fill: "#71839B"
  }))));
};
export default SvgDocumentSign;